import { render, staticRenderFns } from "./documentsMain.vue?vue&type=template&id=115c6b76&scoped=true"
import script from "./documentsMain.vue?vue&type=script&lang=js"
export * from "./documentsMain.vue?vue&type=script&lang=js"
import style0 from "./documentsMain.vue?vue&type=style&index=0&id=115c6b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115c6b76",
  null
  
)

export default component.exports